(function () {

    angular
        .module('smartertoolsApp')
        .controller('cartContentsController',
            [
                '$scope', '$location', '$timeout', 'ticketService', '$q', 'authenticationService', '$rootScope', 'cacheControl', 'userPartnerService', 'hostingService', '$http',
                cartContentsController
            ]);

    function cartContentsController($scope, $location, $timeout, ticketService, $q, authenticationService, $rootScope, cacheControl, partnerService, hostingService, $http) {
        const vm = this;
        vm.agreeToInvoiceTerms = false;
        vm.cartGuid = SessionStorageWithFallback.get('smartertoolsCartGuid');
        vm.cartGuidForAgentList = null;
        vm.checkoutFailureMessage = 'FAILURE_MESSAGE';
        vm.checkoutStage = 'checkout';
        vm.countryList = geographicLocations.countries;
        vm.customerEmail = authenticationService.getLoggedInEmail();
        vm.displayItems = [];
        vm.emergencyTicket = null;
        vm.grandTotal = 0;
        vm.hasContents = false;
        vm.invoiceNumber = 'INVOICE_NUMBER';
        vm.isReseller = authenticationService.isReseller();
        vm.isSupportAndNotReseller = false;
        vm.items = [];
        vm.referenceNumber = '';
        vm.selectedPaymentMethod = null;
        vm.selectedPaymentMethodId = 'new';
        vm.selectedStaffMember = null;
        vm.sentEmergencyTicket = false;
        vm.showDiscountColumn = false;
        vm.showTaxColumn = false;
        vm.showTotalColumn = false;
        vm.stateList = geographicLocations.statesByCountry;
        vm.totalDiscount = 0;
        vm.totalPrice = 0;
        vm.totalTax = 0;

        // Functions
        vm.addonsExpire = addonsExpire;
        vm.addonName = addonName;
        vm.backFromPaymentText = backFromPaymentText;
        vm.backFromPaymentUrl = backFromPaymentUrl;
        vm.checkPartnershipsAndHosted = checkPartnershipsAndHosted;
        vm.clearAll = clearAll;
        vm.clearTickets = clearTickets;
        vm.completePurchase = completePurchase;
        vm.getPrimaryEmail = getPrimaryEmail;
        vm.getStaffImage = getStaffImage;
        vm.gotoPaymentPage = gotoPaymentPage;
        vm.goToVerification = goToVerification;
        vm.loadStaffList = loadStaffList;
        vm.refreshCartContents = refreshCartContents;
        vm.initialLoadCartContents = initialLoadCartContents;
        vm.removeItem = removeItem;
        vm.scrollTop = scrollTop;
        vm.selectedPaymentMethodChanged = selectedPaymentMethodChanged;
        vm.selectStaff = selectStaff;
        vm.setFromCartContents = setFromCartContents;
        vm.setStage = setStage;
        vm.setTicketsFromCartContents = setTicketsFromCartContents;
        vm.submitTickets = submitTickets;
        vm.ticketDoContinueCheckout = ticketDoContinueCheckout;

        activate();

        // -----------------------------------------------

        function activate() {
            $scope.load = function () {
                if ($location.path() === '/checkout' && vm.checkoutStage === 'checkout') {
                    if (!vm.cartGuid)
                        location.href = '/purchase/select-product.html';
                    else
                        vm.gotoPaymentPage();
                }
            };

            autoSpinner = true;
            $scope.load();
            vm.initialLoadCartContents();
            vm.getPrimaryEmail();
            vm.checkPartnershipsAndHosted();

            // TESTING - This next section will show the thank you page, so it can be worked on
            //$timeout(function() {
            //    vm.invoiceNumber = '2110136230';
            //    vm.isSupportAndNotReseller = false;
            //    vm.checkoutFailureMessage = null;
            //    vm.cartGuidForAgentList = '4055e5f4-9a0c-40c2-ba84-6ce99a8250c1';
            //    vm.loadStaffList(function () { vm.setStage("charge-success"); });
            //}, 500);
        }

        function addonsExpire(item) {
            let expires = null;
            item.Addons.forEach(function (addon) {
                if (addon.ExpiresUtc && !expires)
                    expires = addon.ExpiresUtc;
            });
            return expires;
        }

        function addonName(addon) {
            let name = addon.Name;
            if (!addon.ExpiresUtc)
                return name;

            const options = { dateStyle: 'medium' };

            // The following if statement is mostly so that we can style the expiration note 
            // differently for the main renewal notice if we so desire
            const exDate = new Date(addon.ExpiresUtc);
            const dateString = exDate.toLocaleDateString(undefined, options);
            if (name === '<b>INCLUDES</b>: 12 months of Maintenance and Support' ||
                name === '12 months of Maintenance and Support' ||
                name === 'Maintenance and Support' ||
                name === 'Maintenance and Support Reinstatement') {
                name += ` <span class="item-expiration-note-main">(expires ${dateString})</span>`;
            } else {
                name += ` <span class="item-expiration-note">(expires ${dateString})</i></span>`;
            }
            return name;
        }

        function backFromPaymentText() {
            return vm.emergencyTicket ? 'Ticket Details' : 'Shopping Cart';
        }

        function backFromPaymentUrl() {
            return '/purchase/#/' + (vm.emergencyTicket ? 'ticket-details' : '');
        }

        function checkPartnershipsAndHosted() {
            $q
                .all([
                    partnerService.getPartnershipDetails(),
                    hostingService.getServices()
                ])
                .then(function (arr) {
                    vm.IsActivePartner = arr[0] && arr[0].IsActivePartner;

                    let hostedData = arr[1];
                    if (hostedData.Services) {
                        for (let i = 0; i < hostedData.Services.length; i++) {
                            if (hostedData.Services[i].Status === 'active' || hostedData.Services[i].Status === 'trial') {
                                vm.hasHosted = true;
                                break;
                            }
                        }
                    }
                });
        }

        function clearAll() {
            vm.hasContents = false;
            vm.showTaxColumn = false;
            vm.showDiscountColumn = false;
            vm.showTotalColumn = false;
            vm.totalPrice = 0;
            vm.totalDiscount = 0;
            vm.totalTax = 0;
            vm.grandTotal = 0;
            vm.items = [];
            vm.displayItems = [];
            vm.cartGuid = null;
            vm.emergencyTicket = null;
            vm.includesEmergencyTicket = false;
            vm.customerEmail = null;
            SessionStorageWithFallback.set('smartertoolsCartItemCount', 0);
            SessionStorageWithFallback.set('smartertoolsCartGuid', '');
            SessionStorageWithFallback.set('smartertoolsPreCart', '');
            SessionStorageWithFallback.set('RemovalItemId', '');
        }

        function clearTickets() {
            vm.emergencyTicket = null;

            for (let item in vm.displayItems) {
                if (!vm.displayItems.hasOwnProperty(item)) continue;
                let key = `${item.ProductId}_${item.Id}_ticketDetails`;
                sessionStorage.removeItem(key);
            }
        }

        function completePurchase() {
            if (vm.selectedPaymentMethodId === 'invoice') {
                $http.post(`${apiRootUrl}v1/cart/complete-purchase/invoice-later`, JSON.stringify({ CartId: vm.cartGuid }))
                    .then(response => {
                        let data = response.data;
                        if (data.Charged) {
                            submitTickets(function () {
                                onComplete(data);
                            });
                        } else {
                            vm.checkoutFailureMessage = data.ResultMessage;
                            vm.setStage('charge-failure');
                        }
                    }, () => {
                    });
            } else if (vm.selectedPaymentMethodId === 'new') {
                let d = vm.selectedPaymentMethod;
                d.CartId = vm.cartGuid;

                $http.post(`${apiRootUrl}v1/cart/complete-purchase/new-card`, JSON.stringify(d))
                    .then(function (response) {
                        let data = response.data;
                        if (data.Charged) {
                            submitTickets(() => {
                                onComplete(data);
                            });
                        } else {
                            vm.checkoutFailureMessage = data.ResultMessage;
                            vm.setStage('charge-failure');
                        }
                    }, () => {
                    });
            } else {
                let d2 = vm.selectedPaymentMethod;
                d2.CartId = vm.cartGuid;

                $http.post(`${apiRootUrl}v1/cart/complete-purchase/card-on-file`, JSON.stringify(d2))
                    .then(response => {
                        let data = response.data;
                        if (data.Charged) {
                            submitTickets(function () {
                                onComplete(data);
                            });
                        } else {
                            vm.checkoutFailureMessage = data.ResultMessage;
                            vm.setStage('charge-failure');
                        }
                    }, () => {
                    });
            }

            function onComplete(data) {
                trackPurchase(data);
                vm.invoiceNumber = data.InvoiceNumber;
                vm.isSupportAndNotReseller = data.isSupportAndNotReseller;
                vm.checkoutFailureMessage = null;
                vm.cartGuidForAgentList = vm.cartGuid;
                vm.clearAll();
                vm.clearTickets();
                cacheControl.clearAllCaches();
                $rootScope.$broadcast('cache-clear', {});
                vm.setStage('charge-success');
                RefreshLoginTopArea();
                $rootScope.$broadcast('userAccessService:changed', {});
                $rootScope.$applyAsync();
            }
        }

        function getPrimaryEmail() {
            ticketService.getAccountSettings()
                .then(data => {
                    if (data) {
                        vm.primaryEmail = data.Details.EmailAddress;
                    }
                });
        }

        function gotoPaymentPage() {
            if (!authenticationService.isLoggedIn()) {
                ShowLoginOverlay(() => vm.gotoPaymentPage());
            } else {
                if ($location.path() === '/'
                    && vm.emergencyTicket) {
                    $location.path('/ticket-details');
                    $scope.$applyAsync();
                    return;
                }
                authenticationService.showTermsCondition(
                    function (data) {
                        const showAgreement = data;
                        if (showAgreement == true) {
                            ShowTermsAgreementOverlay();
                        }
                    });

                $http.post(`${apiRootUrl}v1/cart/payment-methods`, JSON.stringify({}))
                    .then(response => {
                        let data = response.data;
                        vm.availablePaymentMethods = data.Methods;
                        for (let i = 0; i < vm.availablePaymentMethods.length; i++) {
                            vm.availablePaymentMethods[i].SecurityCode = vm.availablePaymentMethods[i].SecurityCode || '';
                            vm.availablePaymentMethods[i].CardNumber = vm.availablePaymentMethods[i].CardNumber || '';
                            vm.availablePaymentMethods[i].NameOnCard = vm.availablePaymentMethods[i].NameOnCard || '';
                            vm.availablePaymentMethods[i].SaveCard = vm.availablePaymentMethods[i].SaveCard || false;
                        }
                        vm.selectedPaymentMethodChanged();
                        vm.setStage('payment');
                        $location.path('/checkout');

                        $scope.$applyAsync();
                        RecalculateAllFloatLabelControls();
                    }, () => {
                        ShowLoginOverlay(() => vm.gotoPaymentPage());
                    });
            }
        }

        function goToVerification() {
            $http.post(`${apiRootUrl}v1/cart/pre-verify`, JSON.stringify({ CartId: vm.cartGuid }))
                .then(response => {
                    let data = response.data;
                    vm.setFromCartContents(data);
                    vm.setStage('verify');
                }, () => {
                });
        }

        function loadStaffList(callback) {
            $.get(`${apiRootUrl}v1/cart/sales-agents`)
                .done(data => {
                    vm.salesAgents = data.Agents;
                    $scope.$applyAsync();
                    if (callback)
                        callback();
                });
        }

        function getStaffImage(id) {
            return id ? `${apiRootUrl}v1/cart/sales-agent-image/${id}` : '/img/employees/no-image.svg';
        }

        function refreshCartContents() {
            if (!vm.cartGuid) {
                vm.clearAll();
                return;
            }

            $http.post(`${apiRootUrl}v1/cart/contents`, JSON.stringify({ CartId: vm.cartGuid }))
                .then(response => {
                    let data = response.data;
                    vm.setFromCartContents(data);
                    vm.setTicketsFromCartContents(data);
                }, () => {
                    vm.setFromCartContents(null);
                    vm.setTicketsFromCartContents(null);
                });
        }

        function initialLoadCartContents() {
            if (!vm.cartGuid) {
                vm.clearAll();
                return;
            }

            $http.post(`${apiRootUrl}v1/cart/contents`, JSON.stringify({ CartId: vm.cartGuid }))
                .then(response => {
                    let data = response.data;
                    let removeItem = data.Items[data.Items.length - 1];
                    SessionStorageWithFallback.set('RemovalItemId', removeItem.Id);
                    vm.setFromCartContents(data);
                    vm.setTicketsFromCartContents(data);
                }, () => {
                    vm.setFromCartContents(null);
                    vm.setTicketsFromCartContents(null);
                });
        }

        function removeItem(item) {
            const url = item.IsUpgrade ? 'v1/cart/remove-upgrade-item' : 'v1/cart/remove-purchase-item';
            $http.post(apiRootUrl + url, JSON.stringify({ CartId: vm.cartGuid, CartItemId: item.Id }))
                .then(response => {
                    let data = response.data;
                    vm.setFromCartContents(data);
                }, () => {
                });
        }

        function scrollTop() {
            window.scrollTo(0, 0);
        }

        function selectedPaymentMethodChanged() {
            if (!vm.availablePaymentMethods)
                return;
            vm.availablePaymentMethods.forEach(p => {
                if (vm.selectedPaymentMethodId &&
                    vm.selectedPaymentMethodId === 'new' &&
                    p &&
                    p.PaymentType === 'new') {
                    vm.selectedPaymentMethod = p;
                } else if (vm.selectedPaymentMethodId === 'invoice' && p.PaymentType === 'invoice') {
                    vm.selectedPaymentMethod = p;
                } else if (vm.selectedPaymentMethodId !== 'new' &&
                    vm.selectedPaymentMethodId !== 'invoice' &&
                    p.PaymentType === 'card' &&
                    p.PaymentMethodId == vm.selectedPaymentMethodId) {
                    vm.selectedPaymentMethod = p;
                }
            });

            $scope.$applyAsync();
            RecalculateAllFloatLabelControls();
        }

        function selectStaff(agentId) {
            // this is a fire and forget call
            $http.post(`${apiRootUrl}v1/cart/sales-agent`, json.stringify({
                agentid: agentid,
                cartguid: vm.cartguidforagentlist
            }))
                .then(() => {
                }, () => {
                });

            vm.selectedstaffmember = agentid;
        }

        function setFromCartContents(data) {
            if (data === null) {
                vm.clearAll();

                $scope.$applyAsync();
                return;
            }
            vm.showTaxColumn = data.ShowTaxColumn;
            vm.showDiscountColumn = data.ShowDiscountColumn;
            vm.showTotalColumn = data.ShowTotalColumn;
            vm.totalPrice = data.TotalPrice;
            vm.totalDiscount = data.TotalDiscount;
            vm.totalTax = data.TotalTax;
            vm.grandTotal = data.GrandTotal;
            vm.referenceNumber = data.ReferenceNumber;

            vm.items = data.Items || [];
            vm.displayItems = [];
            let hasTraining = false;

            vm.isReseller = authenticationService.isReseller();
            for (let i = 0; i < vm.items.length; i++) {
                let item = Object.assign({}, vm.items[i]);
                if (!item)
                    continue;

                if (hasTraining && item.ProductId === 789) {
                    for (let i2 = 0; i2 < vm.displayItems.length; i2++) {
                        let displayItem = vm.displayItems[i2];

                        if (!displayItem || displayItem.ProductId !== 789)
                            continue;

                        displayItem.TotalPrice += item.ListPriceIncludingAddons;
                        displayItem.CartIDs.push(item.Id);
                        displayItem.quantity++;
                        break;
                    }
                } else {
                    if (item.ProductId === 789) {
                        hasTraining = true;
                        item.CartIDs = [];
                        item.CartIDs.push(item.Id);
                    }

                    item.TotalPrice = item.ListPriceIncludingAddons;
                    item.quantity = item.quantity ? item.quantity : 1;
                    vm.displayItems.push(item);
                }

                if (vm.isReseller != null && vm.isReseller && item.Addons.length > 0) {
                    let addons = item.Addons;
                    let indexToRemove = null;
                    for (let j = 0; j < addons.length; j++) {
                        if (addons[j].OriginalProductId == 788)
                            indexToRemove = j;
                    }
                    if (indexToRemove != null)
                        item.Addons.splice(indexToRemove, 1);
                }
            }

            vm.hasContents = vm.items.length > 0;
            SessionStorageWithFallback.set('smartertoolsCartItemCount', vm.items.length);

            $scope.$applyAsync();
            RefreshLoginTopArea();
        }

        function setStage(newStage) {
            vm.checkoutStage = newStage;
            $scope.$applyAsync();
            $timeout(vm.scrollTop, 10);
        }

        function setTicketsFromCartContents(data) {
            if (!data || !data.Items) {
                vm.clearAll();
                $scope.$applyAsync();
                return;
            }

            vm.clearTickets();

            // customer email is actually the logged in user email, so handle accordingly.
            let userEmail = vm.customerEmail === vm.primaryEmail
                ? ''
                : vm.customerEmail;

            for (let i = 0; i < data.Items.length; i++) {
                let details;
                if (data.Items[i].ProductId === 203) {
                    vm.emergencyTicket = {
                        ProductId: data.Items[i].ProductId,
                        CartItemId: data.Items[i].Id,
                        fromEmail: vm.primaryEmail,
                        ccEmail: userEmail
                    };

                    details = JSON.parse(sessionStorage.getItem(`${vm.emergencyTicket.ProductId}_${vm.emergencyTicket.CartItemId}_ticketDetails`));
                    if (details) {
                        vm.emergencyTicket.Product = details.Product;
                        vm.emergencyTicket.ccEmail = details.CCAddress;
                        vm.emergencyTicket.subject = details.Subject;
                        vm.emergencyTicket.phoneNumber = details.Phone;
                        vm.emergencyTicket.message = details.rawBody;
                    }
                }
            }

            $scope.$applyAsync();

            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function submitTickets(callBack) {
            let details = {};
            let sessionKey = '';
            let invoiceNumber = vm.invoiceNumber;
            let sendingEmergencyTicket = false;
            let promises = [];

            // customer email is actually the logged in user email, so handle accordingly.
            let userEmail = vm.customerEmail === vm.primaryEmail
                ? ''
                : vm.customerEmail;

            for (let i = 0; i < vm.items.length; i++) {
                let item = vm.items[i];
                let isFree = false;
                switch (item.ProductId) {
                    case 203:
                        sessionKey = `${item.ProductId}_${item.Id}_ticketDetails`;
                        details = JSON.parse(sessionStorage.getItem(sessionKey));
                        if (!details)
                            continue;

                        details.Invoice = invoiceNumber;
                        promises.push(ticketService.submitTicket(details));
                        sendingEmergencyTicket = true;

                        break;
                    case 788:
                        details = {
                            IsEmergency: false,
                            IsInstall: true,
                            IsTraining: false,
                            FromAddress: vm.primaryEmail,
                            CCAddress: userEmail,
                            Subject: 'SmarterTools Installation Assistance',
                            rawBody: `${vm.primaryEmail} has purchased Installation Assistance.`,
                            Body: `${vm.primaryEmail} has purchased Installation Assistance.`,
                            IsHtml: false,
                            IsFree: isFree
                        };
                        details.Invoice = invoiceNumber;
                        promises.push(ticketService.submitTicket(details));

                        break;
                    case 789:
                        details = {
                            IsEmergency: false,
                            IsInstall: false,
                            IsTraining: true,
                            FromAddress: vm.primaryEmail,
                            CCAddress: userEmail,
                            Subject: 'SmarterTools Product Training',
                            rawBody: `${vm.primaryEmail} has purchased Product Training.`,
                            Body: `${vm.primaryEmail} has purchased Product Training.`,
                            IsHtml: false,
                            IsFree: isFree
                        };

                        details.Invoice = invoiceNumber;
                        promises.push(ticketService.submitTicket(details));

                        break;
                }

                if (vm.isReseller != null && !vm.isReseller) {
                    for (let j = 0; j < item.Addons.length; j++) {
                        let addon = item.Addons[j];
                        isFree = false;
                        switch (addon.OriginalProductId) {
                            case 203:
                                sessionKey = `${item.ProductId}_${item.Id}_ticketDetails`;
                                details = JSON.parse(sessionStorage.getItem(sessionKey));
                                if (!details)
                                    continue;

                                details.Invoice = invoiceNumber;
                                promises.push(ticketService.submitTicket(details));
                                sendingEmergencyTicket = true;

                                break;
                            case 788:
                                isFree = addon.ListPrice <= 0;
                                details = {
                                    IsEmergency: false,
                                    IsInstall: true,
                                    IsTraining: false,
                                    FromAddress: vm.primaryEmail,
                                    CCAddress: userEmail,
                                    Subject: 'SmarterTools Installation Assistance',
                                    rawBody: `${vm.primaryEmail} has submitted an Installation Assistance request.`,
                                    Body: `${vm.primaryEmail} has submitted an Installation Assistance request.`,
                                    IsHtml: false,
                                    IsFree: isFree
                                };
                                details.Invoice = invoiceNumber;
                                promises.push(ticketService.submitTicket(details));

                                break;
                            case 789:
                                details = {
                                    IsEmergency: false,
                                    IsInstall: false,
                                    IsTraining: true,
                                    FromAddress: vm.primaryEmail,
                                    CCAddress: userEmail,
                                    Subject: 'SmarterTools Product Training',
                                    rawBody: `${vm.primaryEmail} has purchased Product Training.`,
                                    Body: `${vm.primaryEmail} has purchased Product Training.`,
                                    IsHtml: false,
                                    IsFree: isFree
                                };

                                details.Invoice = invoiceNumber;
                                promises.push(ticketService.submitTicket(details));

                                break;
                        }
                    }
                }
            }

            if (!promises.length) {
                if (typeof callBack === 'function')
                    callBack();

                return;
            }

            $q.all(promises)
                .then(arr => {
                    cacheControl.getCache('rsaaTicketCache').removeAll();
                    vm.sentEmergencyTicket = sendingEmergencyTicket;
                    vm.clearTickets();
                    if (typeof callBack === 'function')
                        callBack();
                })
                .catch(() => {
                    vm.clearTickets();
                    if (typeof callBack === 'function')
                        callBack();
                });
        }

        function ticketDoContinueCheckout() {
            if (vm.purchasedTicketsForm.$invalid)
                return;

            if (!vm.emergencyTicket.Product)
                return;

            let details;
            let sessionKey;

            if (vm.emergencyTicket) {
                details = {
                    IsEmergency: true,
                    IsInstall: false,
                    IsTraining: false,
                    FromAddress: vm.customerEmail,
                    CCAddress: vm.emergencyTicket.ccEmail,
                    Subject: vm.emergencyTicket.subject,
                    Phone: vm.emergencyTicket.phoneNumber,
                    Product: vm.emergencyTicket.Product,
                    rawBody: vm.emergencyTicket.message,
                    Body: vm.emergencyTicket.message,
                    IsHtml: false
                };

                sessionKey = `${vm.emergencyTicket.ProductId}_${vm.emergencyTicket.CartItemId}_ticketDetails`;
                sessionStorage.setItem(sessionKey, JSON.stringify(details));
            }

            vm.gotoPaymentPage();
        }

        function trackPurchase(data) {
            try {
                if (typeof ga === 'function' && data) {
                    ga('require', 'ecommerce');
                    ga('ecommerce:addTransaction',
                        {
                            'id': data.InvoiceNumber,
                            'affiliation': 'SmarterTools',
                            'revenue': vm.grandTotal
                        });

                    if (vm.items) {
                        for (let index = 0; index < vm.items.length; ++index) {
                            let item = vm.items[index];
                            if (!item)
                                continue;
                            let name = item.Name;
                            if (vm.IsUpgrade)
                                name = 'License Upgrade';
                            ga('ecommerce:addItem',
                                {
                                    'id': item.Id, // Transaction ID. Required.
                                    'name': name, // Product name. Required.
                                    'price': item.FinalPrice, // Unit price.
                                    'quantity': '1' // Quantity.
                                });
                            if (item.Addons) {
                                for (let j = 0; j < item.Addons.length; ++j) {
                                    let addon = item.Addons[j];
                                    if (addon.FinalPrice)
                                        ga('ecommerce:addItem',
                                            {
                                                'id': addon.Id, // Transaction ID. Required.
                                                'name': addon.Name, // Product name. Required.
                                                'price': addon.FinalPrice, // Unit price.
                                                'quantity': '1' // Quantity.
                                            });
                                }
                            }
                        }
                    }
                    ga('ecommerce:send');
                }
            } catch (ex) {
                /* discard errors */
            }
        }
    }

})();